<template>
  <div class="exchange-container">
    <van-nav-bar :title="$t('swap')" left-text="返回" left-arrow>
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="content-box">
      <div class="content">
        <div class="title">{{ $t("swap_currency exchange") }}</div>
        <div class="exchange-box">
          <div class="exchange-box-left" @click="changeType">
            <img src="../../assets/exchange-icon.png" alt="" />
          </div>
          <div class="exchange-box-right">
            <div class="input-row">
              <input
                type="number"
                inputmode="decimal"
                v-model="num"
                @input="numInput"
                :placeholder="$t('swap_please enter exchange amount')"
              />
              <div
                class="select-type"
                v-if="actions1[type1]"
                @click="show1 = true"
              >
                <img
                  v-if="actions1[type1].name == 'USDT'"
                  src="../../assets/USDT.png"
                  class="logo"
                  alt=""
                />
                <img
                  v-if="actions1[type1].name == 'BTC'"
                  src="../../assets/BTC.png"
                  class="logo"
                  alt=""
                />
                <img
                  v-if="actions1[type1].name == 'ETH'"
                  src="../../assets/ETH.png"
                  class="logo"
                  alt=""
                />
                <span v-if="actions1[type1].name">{{
                  actions1[type1].name
                }}</span>
                <img src="../../assets/arrow-down.svg" class="arrow" alt="" />
              </div>
            </div>
            <div class="input-row">
              <input
                type="text"
                v-model="result"
                disabled
                :placeholder="$t('swap_exchange quantity')"
              />
              <div
                class="select-type"
                v-if="actions2[type2]"
                @click="show2 = true"
              >
                <img
                  v-if="actions2[type2].name == 'USDT'"
                  src="../../assets/USDT.png"
                  class="logo"
                  alt=""
                />
                <img
                  v-if="actions2[type2].name == 'BTC'"
                  src="../../assets/BTC.png"
                  class="logo"
                  alt=""
                />
                <img
                  v-if="actions2[type2].name == 'ETH'"
                  src="../../assets/ETH.png"
                  class="logo"
                  alt=""
                />
                <span v-if="actions2[type2].name">{{
                  actions2[type2].name
                }}</span>
                <img src="../../assets/arrow-down.svg" class="arrow" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="exchange-info-bar">
        <div class="exchange-info-bar-left">
          {{ $t("swap_up to") }}:{{ canExchange }}{{ actions1[type1].name }}
        </div>
        <div class="exchange-info-bar-right" @click="exchangeAll">
          {{ $t("swap_redeem all") }}
        </div>
      </div>
      <div class="exchange-info-row">
        <div class="exchange-info-row-left">
          {{ $t("swap_exchange rate") }}:
        </div>
        <div class="exchange-info-row-right">
          {{ exchangeRate < 1 ? exchangeRate.toFixed(8) : exchangeRate }}
        </div>
      </div>
      <div class="exchange-info-row">
        <div class="exchange-info-row-left">
          {{ $t("swap_available") }}{{ actions2[type2].name }}:
        </div>
        <div class="exchange-info-row-right">{{ result ? result : 0 }}</div>
      </div>
      <div class="confirm-btn" @click="exchange">{{ $t("exchange.confirm") }}</div>
    </div>
    <van-action-sheet
      :cancel-text="$t('cancel')"
      close-on-click-action
      v-model="show1"
      :actions="actions1"
      @select="onSelect1"
    />
    <van-action-sheet
      :cancel-text="$t('cancel')"
      close-on-click-action
      v-model="show2"
      :actions="actions2"
      @select="onSelect2"
    />
  </div>
</template>

<script>
import Decimal from "decimal.js";

export default {
  data() {
    return {
      actions1: [{ name: "USDT" }, { name: "ETH" }, { name: "BTC" }],
      actions2: [{ name: "USDT" }, { name: "ETH" }, { name: "BTC" }],
      show1: false,
      show2: false,
      currencyRate: [],
      type1: 1,
      type2: 0,
      userInfo: "",
      exchangeRate: 0,
      canExchange: 0,
      num: "",
      result: "",
    };
  },
  created() {
    this.getCurrencyRate();
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.canExchange = this.userInfo.balance_usdt
  },
  methods: {
    exchangeAll() {
      this.num = this.canExchange;
      this.computedRate();
      setTimeout(() => {
        this.computedMoney();
      }, 300);
    },
    numInput() {
      if (this.num != "") {
        this.result = new Decimal(this.num)
          .mul(new Decimal(this.exchangeRate))
          .toNumber();
        if (this.result.toString().split(".")[1].length > 5) {
          this.result = this.result.toFixed(8);
        }
      }
    },
    changeType() {
      let type1 = this.type1;
      let type2 = this.type2;
      this.type1 = type2;
      this.type2 = type1;
      this.computedRate();
      setTimeout(() => {
        this.computedMoney();
      }, 300);
    },
    navBack() {
      this.$router.replace('/user');
    },
    onSelect1(e) {
      if (e.name == this.actions2[this.type2].name) {
        let type1 = this.type1;
        let type2 = this.type2;
        this.type1 = type2;
        this.type2 = type1;
      } else {
        this.type1 = this.actions2.findIndex((item) => item.name == e.name);
      }
      this.computedRate();
      setTimeout(() => {
        this.computedMoney();
      }, 300);
    },
    onSelect2(e) {
      if (e.name == this.actions1[this.type1].name) {
        let type1 = this.type1;
        let type2 = this.type2;
        this.type1 = type2;
        this.type2 = type1;
      } else {
        this.type2 = this.actions2.findIndex((item) => item.name == e.name);
      }
      this.computedRate();
      setTimeout(() => {
        this.computedMoney();
      }, 300);
    },
    computedRate() {
      this.exchangeRate = new Decimal(this.currencyRate[this.type1].rate).div(
        new Decimal(this.currencyRate[this.type2].rate)
      );
    },
    computedMoney() {
      if (this.type1 == 0) {
        this.canExchange = this.userInfo.balance_usdt;
      }
      if (this.type1 == 1) {
        this.canExchange = this.userInfo.balance_eth;
      }
      if (this.type1 == 2) {
        this.canExchange = this.userInfo.balance_btc;
      }
      if (this.num != "") {
        this.result = new Decimal(this.num)
          .mul(new Decimal(this.exchangeRate))
          .toNumber();
        if (this.result.toString().split(".")[1].length > 5) {
          this.result = this.result.toFixed(8);
        }
      }
    },
    async getCurrencyRate() {
      const res = await this.$api.getCurrencyRate();
      if (res.code == 200) {
        this.currencyRate = res.data;
        this.actions1 = res.data.map((item) => {
          return {
            name: item.currency.toUpperCase(),
          };
        });
        this.actions2 = res.data.map((item) => {
          return {
            name: item.currency.toUpperCase(),
          };
        });
        // if(localStorage.getItem('currentCurrency') == 'eth') {
        //   this.type1 = this.currencyRate.findIndex(item=> item.currency == 'eth')
        // } else {
        //   this.type1 = this.currencyRate.findIndex(item=> item.currency == 'trx')
        // }

        this.exchangeRate = new Decimal(this.currencyRate[this.type1].rate).div(
          new Decimal(this.currencyRate[this.type2].rate)
        );
        this.computedMoney();
      }
    },
    async exchange() {
      if (this.num == "") {
        this.$Toast(this.$t("exchange amount cannot be blank"));
        return;
      }
      if (this.num <= 0) {
        this.$Toast(this.$t("exchange amount must be greater than 0"));
        return;
      }
      let data = {
        from_currency: this.currencyRate[this.type1].currency,
        to_currency: this.currencyRate[this.type2].currency,
        money: this.num,
      };
      const res = await this.$api.exchange(data);
      if (res.code == 200) {
        this.$Toast(this.$t("successfully redeemed"));
        this.getUserInfo()
      } else {
        this.$Toast(res.message);
      }
    },
    async getUserInfo() {
      const res = await this.$api.getUserInfo();
      if (res.code == 200) {
        this.userInfo = res.data
        if(this.type1 == 0) {
          this.canExchange = res.data.balance_usdt
        }
        if(this.type1 == 1) {
          this.canExchange = res.data.balance_eth
        }
        if(this.type1 == 2) {
          this.canExchange = res.data.balance_btc
        }
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.exchange-container {
  .back {
    width: 30px;
    height: 15px;
  }
  .content-box {
    background: #fff;
    padding: 20px 15px;
    .content {
      .title {
        font-size: 14px;
        font-weight: bold;
      }
      .exchange-box {
        background: #f2f4f7;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 5px 10px;
        border-radius: 5px;
        margin-top: 15px;
        &-left {
          flex: 1;
          img {
            width: 30px;
            height: 30px;
          }
        }
        &-right {
          box-sizing: border-box;
          .input-row {
            display: flex;
            align-items: center;
            input {
              border: none;
              background: transparent;
              font-size: 14px;
              color: #323233;
              padding: 10px;
              padding-left: 20px;
              box-sizing: border-box;
              flex: 1;
            }
            .select-type {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .logo {
                width: 20px;
                height: 20px;
                margin-right: 5px;
              }
              span {
                width: 50px;
              }
              .arrow {
                width: 20px;
                height: 10px;
              }
            }
          }
        }
      }
    }
    .exchange-info-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 15px;
      background: #f2f4f7;
      font-size: 12px;
      padding: 10px 5px;
      border-radius: 3px;
      &-right {
        color: #0062f8;
      }
    }
    .exchange-info-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: bold;
      font-size: 14px;
      margin-top: 20px;
    }
    .confirm-btn {
      padding: 10px 0;
      width: 100%;
      color: #fff;
      margin-top: 20px;
      background: #0062f8;
      border-radius: 3px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
    }
  }
}

@media (min-width: 640px) {
  /deep/ .van-nav-bar__content {
    height: auto;
  }
  /deep/ .van-nav-bar--fixed {
    width: 540px;
    height: 100px;
    left: unset;
  }
  /deep/ .van-popup--bottom {
    width: 540px;
    left: unset;
  }

  .exchange-container {
    .back {
      width: 30px;
      height: 15px;
    }
    .content-box {
      background: #fff;
      padding: 20px 15px;
      .content {
        .title {
          font-size: 14px;
          font-weight: bold;
        }
        .exchange-box {
          background: #f2f4f7;
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 5px 10px;
          border-radius: 5px;
          margin-top: 15px;
          &-left {
            flex: 0;
            img {
              width: 30px;
              height: 30px;
            }
          }
          &-right {
            box-sizing: border-box;
            flex: 1;
            .input-row {
              display: flex;
              align-items: center;
              input {
                border: none;
                background: transparent;
                font-size: 14px;
                color: #323233;
                padding: 10px;
                padding-left: 20px;
                box-sizing: border-box;
                flex: 1;
              }
              .select-type {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .logo {
                  width: 20px;
                  height: 20px;
                  margin-right: 5px;
                }
                span {
                  width: 50px;
                }
                .arrow {
                  width: 20px;
                  height: 10px;
                }
              }
            }
          }
        }
      }
      .exchange-info-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 15px;
        background: #f2f4f7;
        font-size: 12px;
        padding: 10px 5px;
        border-radius: 3px;
        &-right {
          color: #0062f8;
        }
      }
      .exchange-info-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        font-size: 14px;
        margin-top: 20px;
      }
      .confirm-btn {
        padding: 10px 0;
        width: 100%;
        color: #fff;
        margin-top: 20px;
        background: #0062f8;
        border-radius: 3px;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
</style>